import type { ReactNode } from 'react'
import { useInView } from 'react-intersection-observer'

import classnames from 'classnames'

import styles from './AnimateIntoView.module.css'

export enum AnimationType {
  fadeInFromBottom = 'fadeInFromBottom',
  fadeIn = 'fadeIn',
  fadeInFast = 'fadeInFast',
  fadeInFromBottomSm = 'fadeInFromBottomSm',
  overflowUp = 'overflowUp',
  overflowDown = 'overflowDown',
}

export interface AnimateIntoViewProps {
  type?: AnimationType
  children: ReactNode
  delay?: number
}

export default function AnimateIntoView({
  type = AnimationType.fadeInFromBottom,
  children,
  delay,
}: AnimateIntoViewProps) {
  const [ref, inView] = useInView({
    triggerOnce: true,
  })

  const delayStyle = delay ? { transitionDelay: delay + 'ms' } : {}

  return (
    <div
      ref={ref}
      className={classnames(styles[type], inView && styles.inview)}
      style={delayStyle}
    >
      {children}
    </div>
  )
}
